module.exports = __webpack_public_path__ + "img/default.03c565d0.jpg";